import { QueryRequestProvider } from './core/QueryRequestProvider';
import { QueryResponseProvider } from './core/QueryResponseProvider';
import { NewsletterTable } from './table/NewsletterTable';
import { KTCard } from '../../../../_dashboard/helpers';
import { NewsletterListHeader } from './header/NewsletterListHeader';
import { ToastContainer } from 'react-toastify';

const NewsletterList = () => (
  <>
    <KTCard>
      <ToastContainer />
      <NewsletterListHeader />
      <NewsletterTable />
    </KTCard>
  </>
);

const NewsletterListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <NewsletterList />
    </QueryResponseProvider>
  </QueryRequestProvider>
);

export { NewsletterListWrapper };
